<elder-single-pane-wrapper>
  <elder-table
    [data]="data"
    class="flex"
    matSort
    [idField]="'id'"
    (itemClick)="openDetail($event)"
  >
    <!-- icon -->
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
      <td mat-cell *matCellDef="let job">
        @if (job?.state !== JobState.PROCESSING) {
          <mat-icon>dashboard</mat-icon>
        }
        @if (job?.state === JobState.PROCESSING) {
          <mat-spinner mode="indeterminate" diameter="25"></mat-spinner>
        }
      </td>
    </ng-container>

    <!-- facility -->
    <ng-container matColumnDef="reference">
      <th mat-header-cell *matHeaderCellDef>{{ 'jobs.reference' | translate }}</th>
      <td mat-cell *matCellDef="let job">{{ job?.facilityId }}</td>
    </ng-container>

    <!-- interval -->
    <ng-container matColumnDef="interval">
      <th mat-header-cell mat-sort-header="interval" *matHeaderCellDef>
        {{ 'jobs.interval' | translate }}
      </th>
      <td mat-cell *matCellDef="let job">
        {{ job?.interval | isoInterval }}
      </td>
    </ng-container>

    <!-- createdAt -->
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell mat-sort-header="createdAt" *matHeaderCellDef>
        {{ 'audit.createdAt' | translate }}
      </th>
      <td mat-cell *matCellDef="let job">
        {{ job?.createdAt | date: 'medium' }}
      </td>
    </ng-container>

    <!-- startedAt -->
    <ng-container matColumnDef="startedAt">
      <th mat-header-cell mat-sort-header="startedAt" *matHeaderCellDef>
        {{ 'jobs.started' | translate }}
      </th>
      <td mat-cell *matCellDef="let job">
        {{ job?.startedAt | date: 'medium' }}
      </td>
    </ng-container>

    <!-- completedAt -->
    <ng-container matColumnDef="completedAt">
      <th mat-header-cell mat-sort-header="completedAt" *matHeaderCellDef>
        {{ 'jobs.completed' | translate }}
      </th>
      <td mat-cell *matCellDef="let job">
        {{ job?.completedAt | date: 'medium' }}
      </td>
    </ng-container>

    <!-- duration  -->
    <ng-container matColumnDef="duration">
      <th mat-header-cell *matHeaderCellDef>{{ 'jobs.duration' | translate }}</th>
      <td mat-cell *matCellDef="let job">
        {{
          job?.metrics?.metrics?.duration != null
            ? (job?.metrics?.metrics?.duration | isoDuration: 'mm:ss')
            : '-'
        }}
      </td>
    </ng-container>

    <!-- state -->
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef>{{ 'common.status' | translate }}</th>
      <td mat-cell *matCellDef="let job">
        {{ 'jobs.states.' + job?.state | translate }}
      </td>
    </ng-container>
  </elder-table>
</elder-single-pane-wrapper>
